import * as XLSX from 'xlsx';

export const exportClientsToExcel = async (clients, fileName = 'clients_export') => {
  try {
    // Format the data for Excel matching the template structure
    const excelData = clients.map((client) => ({
      'Name': client.name || '',
      'Email': client.email || '',
      'Phone': client.phno || '',
      'Alternate Contact': client.alternateContact || '',
      'Company': client.company || '',
      'GSTIN': client.gstin || '',
      'Address 1': client.addressLine1 || '',
      'Address 2': client.addressLine2 || '',
      'City': client.city || '',
      'State': client.state || '',
      'Zipcode': client.zipcode || '',
      'Country': client.country || '',
      'Access': '', // This field may need to be mapped from your client data
      'High Court Cases': '', // These fields may need to be mapped if you have case relationships
      'District Court Cases': '',
      'Other Court Cases': ''
    }));

    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Convert data to worksheet
    const ws = XLSX.utils.json_to_sheet(excelData);

    // Set column widths for better readability
    const colWidths = [
      { wch: 20 }, // Name
      { wch: 30 }, // Email
      { wch: 15 }, // Phone
      { wch: 15 }, // Alternate Contact
      { wch: 25 }, // Company
      { wch: 20 }, // GSTIN
      { wch: 30 }, // Address 1
      { wch: 30 }, // Address 2
      { wch: 15 }, // City
      { wch: 15 }, // State
      { wch: 10 }, // Zipcode
      { wch: 15 }, // Country
      { wch: 15 }, // Access
      { wch: 25 }, // High Court Cases
      { wch: 25 }, // District Court Cases
      { wch: 25 }, // Other Court Cases
    ];
    ws['!cols'] = colWidths;

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Clients');

    // Generate file name with timestamp
    const timestamp = new Date().toISOString().split('T')[0];
    const finalFileName = `${fileName}_${timestamp}.xlsx`;

    // Write and download the file
    XLSX.writeFile(wb, finalFileName);

    return true;
  } catch (error) {
    console.error('Error exporting clients to Excel:', error);
    throw error;
  }
};